import { ViewModel } from "../mvvm/ViewModel.js";
/** Platform console: Raspberry Pi edge devices for one site. */
export class EdgeDeviceViewModel extends ViewModel {
    client;
    slug;
    constructor(client, slug) {
        super({ devices: [], sandbox: false, provisionToken: null });
        this.client = client;
        this.slug = slug;
    }
    /** Throws on failure so a LivePanel can surface it. */
    async load() {
        this.setState({ devices: await this.client.listEdgeDevices(this.slug) });
    }
    setSandbox(sandbox) {
        this.setState({ sandbox });
    }
    async provision() {
        const { sandbox } = this.state;
        const r = await this.client.provisionEdgeDevice(this.slug, sandbox ? "Sandbox Pi" : "Kitchen Pi", {
            sandbox,
        });
        this.setState({ provisionToken: r.token });
        await this.load();
    }
    async remove(id) {
        await this.client.deleteEdgeDevice(this.slug, id);
        await this.load();
    }
}
//# sourceMappingURL=EdgeDeviceViewModel.js.map